import { BottomSheetModal } from '@gorhom/bottom-sheet'
import React, { RefObject, useEffect, useRef } from 'react'
import { StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native'

import { Text } from 'widgets/Text'

import { UserType } from 'types/user'

import { computeWhereToText } from './utils'

const styles = StyleSheet.create({
  base: {
    paddingVertical: 6,
    paddingHorizontal: 8,
    borderRadius: 5,
    backgroundColor: 'rgba(169, 169, 169, .5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

type WhereToProps = {
  creator: UserType
  combinedCategoriesAndProgramIds: Array<string>
  bottomSheetRef: RefObject<BottomSheetModal>
  containerStyle?: StyleProp<ViewStyle>
  setWidth?: (width: number) => void
  setHeight?: (height: number) => void
}

export const WhereTo = ({
  creator,
  combinedCategoriesAndProgramIds,
  bottomSheetRef,
  containerStyle,
  setWidth,
  setHeight,
}: WhereToProps) => {
  const whereToText = useRef('')

  useEffect(() => {
    computeWhereToText(creator, combinedCategoriesAndProgramIds).then((newWhereToText: string) => {
      whereToText.current = newWhereToText
    })
  }, [combinedCategoriesAndProgramIds, creator])

  const onLayout = (event) => {
    if (setWidth && setHeight) {
      const w = event.nativeEvent.layout.width
      const h = event.nativeEvent.layout.height
      setWidth(w)
      setHeight(h)
    }
  }
  return (
    <>
      {!!whereToText.current && whereToText.current.length > 0 && (
        <TouchableOpacity
          onPress={() => bottomSheetRef?.current?.present()}
          testID='WhereToContainer'
          style={containerStyle ?? styles.base}
          onLayout={onLayout}
        >
          <Text color='white' fontSize='xs' bold numberOfLines={1}>
            {whereToText.current}
          </Text>
        </TouchableOpacity>
      )}
    </>
  )
}
